<template>
  <div style="margin: auto; width: 1000px">
    <h2><center>History Log</center></h2>
    <button type="button" class="btn btn-secondary" @click="backToList">Back</button><br>

    <table class="table table-success table-striped">
      <thead>
        <tr>
          <th scope="col">No</th>
          <th scope="col">Food Id</th>
          <th scope="col">Title</th>
          <th scope="col">Description</th>
          <th scope="col">Updated By</th>
          <th scope="col">Updated At</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(history, index) in histories" :key="history.id">
          <td>{{ index + 1 }}</td>
          <td>{{ history.entityId }}</td>
          <td>{{ history.title }}</td>
          <td>{{ history.description }}</td>
          <td>{{ history.User.fullName }}</td>
          <td>{{ history.updatedAt }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "../apis/server";
export default {
  name: "History",
  data() {
    return {
      histories: [],
    }
  },
  methods:{
    backToList(){
      this.$emit('backToList')
    }
  },
  created() {
    axios({
      url: `/histories`,
      method: "GET",
      headers: { access_token: localStorage.getItem("access_token") },
    }).then(({ data }) => {
      this.histories = data;
      console.log(this.histories);
    });
  },
};
</script>

<style>
</style>